/* RELICT — theme.js */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-overlay]');

  /* ---------- Mobile menu ---------- */
  function closeMenu() {
    document.querySelectorAll('[data-mobile-menu]').forEach(function (m) { m.removeAttribute('data-open'); });
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-menu-open]');
    if (openBtn) {
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) {
        menu.setAttribute('data-open', '');
        if (overlay) overlay.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      return;
    }
    if (e.target.closest('[data-menu-close]') || e.target === overlay) closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      document.querySelectorAll('[data-localization-list]').forEach(function (l) { l.hidden = true; });
    }
  });

  /* ---------- Localization dropdowns ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-localization-trigger]');
    document.querySelectorAll('[data-localization]').forEach(function (wrap) {
      var list = wrap.querySelector('[data-localization-list]');
      if (!list) return;
      if (trigger && wrap.contains(trigger)) {
        list.hidden = !list.hidden;
        wrap.querySelector('[data-localization-trigger]').setAttribute('aria-expanded', String(!list.hidden));
      } else {
        list.hidden = true;
        var t = wrap.querySelector('[data-localization-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.querySelectorAll('[data-localization-form]').forEach(function (form) {
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('button[value]');
      if (!btn) return;
      var input = form.querySelector('input[name="locale_code"], input[name="country_code"]');
      if (input) input.value = btn.value;
      form.submit();
    });
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded;
    });
  });

  /* ---------- Product gallery ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.full;
        mainImg.srcset = thumb.dataset.srcset || '';
        mainImg.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var money = form.dataset.moneyFormat || '{{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      return money.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());
    }

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        opts[parseInt(group.dataset.optionIndex, 10)] = checked ? checked.value : (select ? select.value : null);
      });
      return opts;
    }

    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return o == null || v.options[i] === o; });
      });

      form.querySelectorAll('.swatch').forEach(function (s) {
        var input = s.querySelector('input');
        s.classList.toggle('swatch--active', !!(input && input.checked));
      });

      if (!match) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.dataset.unavailable || 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '<span class="' + (match.compare_at_price > match.price ? 'price--sale' : '') + '">' + formatMoney(match.price) + '</span>';
        if (match.compare_at_price > match.price) {
          html += '<span class="price__compare">' + formatMoney(match.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available
          ? (submitBtn.dataset.addLabel || 'Add to cart')
          : (submitBtn.dataset.soldout || 'Sold out');
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', update);
    update();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyChange, 10);
    input.value = Math.max(parseInt(input.min || '1', 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart line item auto-submit ---------- */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) form.submit();
    });
  });

  /* ---------- Collection sort auto-submit ---------- */
  var sortForm = document.querySelector('[data-sort-form]');
  if (sortForm) sortForm.addEventListener('change', function () { sortForm.submit(); });


  /* ---------- Product slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-slideshow-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var section = root.closest('section') || root;
    var prevBtn = section.querySelector('[data-slideshow-btn="-1"]');
    var nextBtn = section.querySelector('[data-slideshow-btn="1"]');
    var dotsWrap = root.querySelector('[data-slideshow-dots]');
    var rtl = document.documentElement.dir === 'rtl';
    var timer = null;

    function step() {
      return slides[0].getBoundingClientRect().width +
             parseFloat(getComputedStyle(track).columnGap || '16');
    }

    function perView() {
      return Math.max(1, Math.round(track.clientWidth / step()));
    }

    function pages() {
      return Math.max(1, slides.length - perView() + 1);
    }

    function currentIndex() {
      return Math.round(Math.abs(track.scrollLeft) / step());
    }

    var duration = parseInt(root.dataset.duration, 10) || 320;
    var animating = null;

    function animateTo(target) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.scrollLeft = target;
        return;
      }
      if (animating) cancelAnimationFrame(animating);
      var start = track.scrollLeft;
      var delta = target - start;
      var t0 = performance.now();
      function frame(now) {
        var p = Math.min((now - t0) / duration, 1);
        var eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        track.scrollLeft = start + delta * eased;
        if (p < 1) { animating = requestAnimationFrame(frame); } else { animating = null; sync(); }
      }
      animating = requestAnimationFrame(frame);
    }

    function goTo(i) {
      var max = slides.length - perView();
      var target = Math.min(Math.max(i, 0), max) * step();
      animateTo(rtl ? -target : target);
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'slideshow__dot';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.dataset.index = i;
        dotsWrap.appendChild(dot);
      }
      syncDots();
    }

    function syncDots() {
      if (!dotsWrap) return;
      var idx = currentIndex();
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
        d.setAttribute('aria-current', String(i === idx));
      });
    }

    function syncButtons() {
      var idx = currentIndex();
      var max = slides.length - perView();
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= max;
    }

    function sync() { syncDots(); syncButtons(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); goTo(currentIndex() + 1); });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var d = e.target.closest('.slideshow__dot');
        if (!d) return;
        stop();
        goTo(parseInt(d.dataset.index, 10));
      });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(sync, 90);
    });

    function start() {
      if (root.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (slides.length <= perView()) return;
      stop();
      timer = setInterval(function () {
        var max = slides.length - perView();
        goTo(currentIndex() >= max ? 0 : currentIndex() + 1);
      }, parseInt(root.dataset.interval, 10) || 2500);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    window.addEventListener('resize', function () { buildDots(); sync(); });

    buildDots();
    sync();
    start();
  });


  /* ---------- Header predictive search ---------- */
  (function () {
    var panel = document.querySelector('[data-search-panel]');
    if (!panel) return;

    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var form = panel.querySelector('[data-search-form]');
    var toggles = document.querySelectorAll('[data-search-open]');
    var debounce = null;
    var controller = null;

    var STRINGS = {
      searching: panel.dataset.searching || 'Searching…',
      none: panel.dataset.none || 'No products found.',
      all: panel.dataset.all || 'View all results'
    };

    function openPanel() {
      panel.hidden = false;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      if (input) { input.focus(); input.select(); }
    }

    function closePanel() {
      panel.hidden = true;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      if (results) { results.hidden = true; results.innerHTML = ''; }
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        if (panel.hidden) { openPanel(); } else { closePanel(); }
      });
    });

    panel.querySelectorAll('[data-search-close]').forEach(function (b) {
      b.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) closePanel();
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || e.target.closest('[data-search-open]')) return;
      closePanel();
    });

    function render(products, term) {
      if (!results) return;
      if (!products.length) {
        results.innerHTML = '<p class="search-panel__status">' + STRINGS.none + '</p>';
        results.hidden = false;
        return;
      }
      var html = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var price = p.price ? p.price : '';
        var compare = (p.compare_at_price && p.compare_at_price !== p.price) ? '<s>' + p.compare_at_price + '</s>' : '';
        return '<a class="search-result" href="' + p.url + '">' +
          (img ? '<img class="search-result__img" src="' + img + '" alt="" loading="lazy" width="54" height="68">' : '') +
          '<span class="search-result__body">' +
            '<span class="search-result__title">' + p.title + '</span>' +
            '<span class="search-result__price">' + price + compare + '</span>' +
          '</span></a>';
      }).join('');
      html += '<a class="search-panel__all" href="/search?q=' + encodeURIComponent(term) + '&type=product">' + STRINGS.all + '</a>';
      results.innerHTML = html;
      results.hidden = false;
    }

    function search(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      results.innerHTML = '<p class="search-panel__status">' + STRINGS.searching + '</p>';
      results.hidden = false;

      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
                '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, term);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          results.innerHTML = '<p class="search-panel__status">' + STRINGS.none + '</p>';
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(debounce);
        if (term.length < 2) {
          if (controller) controller.abort();
          results.hidden = true;
          results.innerHTML = '';
          return;
        }
        debounce = setTimeout(function () { search(term); }, 220);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!input || input.value.trim().length < 2) e.preventDefault();
      });
    }
  })();


  /* ---------- Collection filters ---------- */
  document.querySelectorAll('[data-facet-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = open;
    });
  });

  /* open the panel automatically when filters are already applied */
  (function () {
    var btn = document.querySelector('[data-facet-toggle]');
    if (!btn || !btn.querySelector('.facet-count')) return;
    btn.setAttribute('aria-expanded', 'true');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = false;
  })();

  /* drop empty inputs so the URL stays clean */
  document.querySelectorAll('[data-facet-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      form.querySelectorAll('input[type="number"]').forEach(function (i) {
        if (!i.value) i.disabled = true;
      });
    });
  });


  /* ---------- Discount popup ---------- */
  (function () {
    var popup = document.querySelector('[data-popup]');
    if (!popup) return;

    var KEY = 'relict_popup_' + (popup.dataset.version || 'v1');
    var frequency = popup.dataset.frequency || 'session';
    var lastFocus = null;

    function seen() {
      if (frequency === 'always') return false;
      try {
        if (frequency === 'session') return sessionStorage.getItem(KEY) === '1';
        var stamp = localStorage.getItem(KEY);
        if (!stamp) return false;
        if (frequency === 'once') return true;
        return (Date.now() - parseInt(stamp, 10)) < 7 * 24 * 60 * 60 * 1000;
      } catch (e) { return false; }
    }

    function remember() {
      try {
        if (frequency === 'session') { sessionStorage.setItem(KEY, '1'); }
        else if (frequency !== 'always') { localStorage.setItem(KEY, String(Date.now())); }
      } catch (e) { /* private mode */ }
    }

    function open() {
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var field = popup.querySelector('input, button');
      if (field) field.focus();
    }

    function close() {
      popup.hidden = true;
      document.body.style.overflow = '';
      remember();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) close();
    });

    /* keep focus inside the dialog while it is open */
    popup.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || popup.hidden) return;
      var f = popup.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Shopify reloads with ?contact_posted=true after a successful submit */
    var justSubmitted = popup.querySelector('[data-popup-success]') !== null;
    if (justSubmitted) {
      open();
      remember();
    } else if (!seen()) {
      var delay = parseInt(popup.dataset.delay, 10);
      if (isNaN(delay)) delay = 4000;
      setTimeout(function () { if (popup.hidden) open(); }, delay);
    }

    /* copy the discount code */
    var codeBtn = popup.querySelector('[data-copy-code]');
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.dataset.copyCode;
        var label = codeBtn.querySelector('[data-copy-label]');
        var done = function () {
          if (!label) return;
          var original = label.textContent;
          label.textContent = label.dataset.copied || 'Copied';
          setTimeout(function () { label.textContent = original; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    }
  })();


  /* ---------- "Size guide" link opens the matching accordion ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-open-accordion]');
    if (!trigger) return;
    var target = document.getElementById('Acc-' + trigger.dataset.openAccordion);
    if (!target) return;
    e.preventDefault();
    var btn = target.querySelector('.accordion__trigger');
    var panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (btn && panel && btn.getAttribute('aria-expanded') !== 'true') {
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.setAttribute('data-flash', '');
    setTimeout(function () { target.removeAttribute('data-flash'); }, 1200);
  });

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
